import React from 'react';
import { Radio } from 'antd';

const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;

const CountPercentageTabs = ({ onToggle, value }) => {
  const memoizedHandleToggle = React.useCallback(
    (e) => {
      onToggle(e.target.value);
    },
    [onToggle],
  );
  return (
    <RadioGroup value={value} onChange={memoizedHandleToggle}>
      <RadioButton id="trends-dimensions-count" value="#">
        #
      </RadioButton>
      <RadioButton id="trends-dimensions-percent" value="%">
        %
      </RadioButton>
    </RadioGroup>
  );
};

export default CountPercentageTabs;
